import React from 'react';
import { Link } from 'react-router-dom';
import '../CSS/styles.css';

const Footer = () => {
  return (
    <footer className='site-footer'>
      <div className='container footer-content'>
        <p className='footer-copyright'>
          &copy; {new Date().getFullYear()} Benjamin Anoh
        </p>
        <div className='footer-social-links' aria-label='App and social links'>
          <Link
            to='/apps'
            className='footer-social-link'
            aria-label='View iOS apps'>
            <i className='fab fa-app-store-ios' aria-hidden='true'></i>
          </Link>
          <a
            href='https://www.linkedin.com/in/kadjo-b-a-1bb753a9/'
            className='footer-social-link'
            aria-label='View LinkedIn profile'
            target='_blank'
            rel='noreferrer'>
            <i className='fab fa-linkedin-in' aria-hidden='true'></i>
          </a>
          <a
            href='https://www.instagram.com/ben_anoh/?hl=en'
            className='footer-social-link'
            aria-label='View Instagram profile'
            target='_blank'
            rel='noreferrer'>
            <i className='fab fa-instagram' aria-hidden='true'></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
